module.exports = __webpack_public_path__ + "static/media/Empty_container.31e2feea.svg";